import { gql } from '@apollo/client'

import type { BaseApplicantOverviewResponseModel } from '@/lib/apollo/model/applicant'
import type { PaginatedDataResponse } from '@/lib/apollo/model/pagination'
import type { Squad } from '@/utils/squad'

export type QueryVars = {
  customerId: string
  squad: Squad
  limit: number
  offset: number
}

export type Over60HoursApplicantResponse = Pick<
  BaseApplicantOverviewResponseModel,
  'id' | 'fullName' | 'joinedQueueAt'
>

export type Response = {
  getOver60HoursApplicants: PaginatedDataResponse<Over60HoursApplicantResponse>
}

const query = gql`
  query ($customerId: String!, $squad: Squad!, $limit: Int!, $offset: Int!) {
    getOver60HoursApplicants(
      customerId: $customerId
      squad: $squad
      limit: $limit
      offset: $offset
    ) {
      total
      offset
      results {
        id
        fullName
        joinedQueueAt
      }
    }
  }
`

export default query
